import { Outlet, useRouterState } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

export default function EmptyLayout() {
    const routerState = useRouterState();
    const [ isTransitioning, setIsTransitioning ] = useState(false);

    useEffect(() => {
        setIsTransitioning(true);
        const timer = setTimeout(() => setIsTransitioning(false), 300);
        return () => clearTimeout(timer);
    }, [ routerState.location.pathname ]);

    return (
        <div className="flex min-h-screen flex-col">
            <main className="flex-1">
                <div
                    className={`transition-all duration-300 ${isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
                        }`}
                >
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
